import dynamic from 'next/dynamic';
import Head from 'next/head';
import type { AppPropsWithLayout } from 'types/page';
import DocsSessionProvider from 'screens/ApiDocsPage/DocsSession';
import 'tailwindcss/tailwind.css';
import '@ionic/react/css/core.css';
import 'styles/globals.css';

// Public developer docs need no account context or session-recording scripts. Loading the app
// providers only on app pages also keeps their analytics initialization away from API credentials.
const ApplicationProviders = dynamic(() => import('components/ApplicationProviders'));
const ThemeProvider = dynamic(() => import('context/ThemeProvider'));

export default function MyApp(props: AppPropsWithLayout & { err?: unknown }) {
  if (props.Component.isDeveloperDocs)
    return (
      <DocsSessionProvider>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        <props.Component {...props.pageProps} />
      </DocsSessionProvider>
    );
  // Firebase account links hold a one-time code in the URL. No analytics, session recording or
  // account providers load there, so the code reaches no third party.
  if (props.Component.isAuthAction)
    return (
      <ThemeProvider>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        <props.Component {...props.pageProps} />
      </ThemeProvider>
    );
  return <ApplicationProviders {...props} />;
}
